import { Space } from 'antd'
import CIMSBadge from 'components/CIMSBadge'
import { CIMSTag } from 'components/CIMSTag'
import type { ApprovalsWorkflowField } from '../types'

type ApprovalDetailsProps = {
  field: ApprovalsWorkflowField
}

/**
 * Summarizes active approval options and their number of assigned approvers.
 */
const ApprovalDetails: React.VFC<ApprovalDetailsProps> = ({ field }) => {
  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      {field.settings.options
        .filter(({ deleted }) => deleted === null)
        .map(({ approverIds, id, label, tooltip }) => (
          <Space key={id} size="small" wrap>
            <CIMSTag tooltip={tooltip}>{label}</CIMSTag>
            <CIMSBadge count={approverIds.length} showZero>
              approvers
            </CIMSBadge>
          </Space>
        ))}
    </Space>
  )
}

export default ApprovalDetails
